export const TEMPLATE_PATHS = {
  functionalLibrary: '/templates/functional-test-library-template.json',
  functionalHistory: '/templates/functional-history-template.json',
  chaosLibrary: '/templates/chaos-experiment-library-template.json',
  chaosHistory: '/templates/chaos-history-template.json',
} as const;

export const DOC_PATHS = {
  apiQuickstart: '/docs/onboarding/api-quickstart.html',
  dataUploadFormats: '/docs/onboarding/data-upload-formats.html',
  observabilitySetup: '/docs/onboarding/observability-setup.html',
} as const;
